import React, { useContext } from 'react';

import RegionDetailsContext from '@totem/components/portfolio/regions/details/RegionDetailsContext';
import { isNotNull } from '@totem/utilities/common';

const RegionDetailsPageTitle = () => {
  const { region } = useContext(RegionDetailsContext);

  return <span>{isNotNull(region) ? region.name : ''}</span>;
};

export default RegionDetailsPageTitle;
